/**
 * Register the PWA service worker so the app can be installed to the home
 * screen on iOS / Android / desktop, and keep the installed app a MIRROR of
 * the live site:
 *   • checks for a new deploy every 5 minutes and whenever the app regains
 *     focus (installed PWAs otherwise only check on cold launch)
 *   • a freshly-installed worker is told to take over immediately
 *   • when the new worker takes control the page reloads ONCE so the user
 *     is on the newest bundle without doing anything.
 * Skipped on true localhost dev to avoid stale-asset issues while iterating.
 */
export function registerServiceWorker() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  const host = window.location.hostname || "";
  const isLocalDev = host === "localhost" || host === "127.0.0.1";
  if (isLocalDev) return;

  let reloaded = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloaded) return;
    reloaded = true;
    window.location.reload();
  });

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { updateViaCache: "none" })
      .then((reg) => {
        const activateWaiting = () => {
          if (reg.waiting) reg.waiting.postMessage({ type: "SKIP_WAITING" });
        };
        activateWaiting();
        reg.addEventListener("updatefound", () => {
          const nw = reg.installing;
          if (!nw) return;
          nw.addEventListener("statechange", () => {
            if (nw.state === "installed" && navigator.serviceWorker.controller) activateWaiting();
          });
        });
        const check = () => reg.update().catch(() => {});
        setInterval(check, 5 * 60 * 1000);
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") check();
        });
      })
      .catch((err) => console.warn("Service worker registration failed:", err));
  });
}
